import axios from 'axios'
import security from '@/services/security.js'

export default {
  validate (invitationCode, courseName) {
    const config = { headers: security.getAuthHeader() }
    const data = {
      InvitationCode: invitationCode,
      CourseName: courseName
    }
    return axios.post('/invite/validate', data, config)
      .then(response => {
        return response.data
      })
  },
  get (courseKey, scouterKey, courseScouterTypeId) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/invite/' + courseKey + '/' + scouterKey + '/' + courseScouterTypeId, config)
      .then(response => {
        return response.data
      })
  },
  accept (userScouterKey, invitationScouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/invite/accept/' + userScouterKey + '/' + invitationScouterKey, config)
      .then(response => {
        return response.data
      })
  }
}
